import { useState, useEffect } from 'react'
import { apiFetch } from '../lib/api'

export default function ForgotPassword() {
  const [email, setEmail] = useState('')
  const [message, setMessage] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const [cooldown, setCooldown] = useState(0)

  // Contador de cooldown
  useEffect(() => {
    if (cooldown > 0) {
      const timer = setTimeout(() => setCooldown(cooldown - 1), 1000)
      return () => clearTimeout(timer)
    }
  }, [cooldown])

  const handleSubmit = async (e) => {
    e.preventDefault()
    setMessage('')
    setError('')
    setLoading(true)

    try {
      const response = await apiFetch('/api/auth/forgot-password', {
        method: 'POST',
        body: JSON.stringify({ email })
      })
      
      const contentType = response.headers?.get?.('content-type') || ''
      const data = contentType.includes('application/json') ? await response.json() : { message: 'Revisa tu correo para instrucciones de reseteo' }
      
      if (response.status === 429) {
        // Rate limit activado
        setError(data.error || 'Por favor espera antes de intentar nuevamente')
        setCooldown(data.waitSeconds || 60)
      } else {
        setMessage(data.message || 'Revisa tu correo para instrucciones de reseteo')
        setEmail('')
        setCooldown(60) // Activar cooldown de 60 segundos después de envío exitoso
      }
    } catch (err) {
      setError(err.message || 'Error al enviar el correo')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-blue-100 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-xl p-8 w-full max-w-md">
        <div className="text-center mb-6">
          <h1 className="text-2xl font-bold text-gray-800">¿Olvidaste tu contraseña?</h1>
          <p className="text-gray-600 mt-2">
            Ingresa tu correo electrónico y te enviaremos instrucciones para resetear tu contraseña
          </p>
        </div>

        {message && (
          <div className="mb-4 p-4 bg-green-50 border border-green-200 rounded-lg">
            <p className="text-green-700 font-semibold mb-3">{message}</p>
            <div className="text-sm text-green-600 bg-white rounded p-3 border border-green-100 space-y-2">
              <p className="font-semibold">💡 Consejos útiles:</p>
              <ul className="list-disc list-inside space-y-1 ml-1">
                <li>Revisa tu carpeta de Correo recibido</li>
                <li>Verifica la carpeta de <strong>SPAM</strong> o <strong>Promociones</strong></li>
                <li>El enlace expira en 1 hora</li>
                <li>Si aún no recibes nada, intenta nuevamente</li>
              </ul>
            </div>
          </div>
        )}

        {error && (
          <div className="mb-4 p-4 bg-red-50 border border-red-200 text-red-700 rounded-lg">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Correo electrónico
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="tu@email.com"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>

          <button
            type="submit"
            disabled={loading || cooldown > 0}
            className="w-full bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed font-medium transition-colors"
          >
            {loading ? 'Enviando...' : cooldown > 0 ? `Espera ${cooldown}s para reintentar` : 'Enviar instrucciones'}
          </button>
        </form>

        <div className="mt-6 text-center">
          <a href="/login" className="text-blue-600 hover:text-blue-700 text-sm font-medium">
            ← Volver al inicio de sesión
          </a>
        </div>
      </div>
    </div>
  )
}
